import { LEARNING_APPS } from '../constants';

// Cache for domain to learning app mapping
const domainCache = new Map<string, string>();

// Precompiled regex patterns
const compiledPatterns = LEARNING_APPS.map(app => ({
  name: app.name,
  regex: new RegExp(app.pattern)
}));

export function getLearningApp(url?: string): string | undefined {
  if (!url) {
    return undefined;
  }

  try {
    // Extract domain from URL if it's a full URL
    let domain = url;
    if (url.includes('://')) {
      domain = new URL(url).hostname;
    }

    // Check cache first
    if (domainCache.has(domain)) {
      return domainCache.get(domain);
    }

    // Find matching app
    const matchingApp = compiledPatterns.find(({ regex }) => regex.test(domain));
    if (matchingApp) {
      // Cache the result
      domainCache.set(domain, matchingApp.name);
      return matchingApp.name;
    }

    return undefined;
  } catch (e) {
    console.warn(`Failed to parse URL in getLearningApp: ${url}`, e);
    return undefined;
  }
}
